import { render, staticRenderFns } from "./UserRoleEdit.vue?vue&type=template&id=0f4bd146"
import script from "./UserRoleEdit.vue?vue&type=script&lang=js"
export * from "./UserRoleEdit.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./UserRoleEdit.vue?vue&type=style&index=1&id=0f4bd146&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports